// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-header-text {
  font-size: 45px;
}

.steps-parent-header {
  margin-top: 10%;
}

.steps-card-container {
  margin-bottom: 10%;
}

.quick-steps-header {
  font-size: 55px;
}

.tutorial-card-container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 18% !important;
}

.tut-card-container {
  display: flex;
  flex-wrap: nowrap; /* Adjust this value as needed to set the spacing between columns */
}

.equal-height-card-wrapper {
  display: flex;
  flex-wrap: nowrap; /* Adjust this value as needed to set the spacing between columns */
}

.tutorial-card-col {
  display: flex;
  flex-wrap: nowrap;
}

@media (max-width: 576px) {
  .tutorial-card-container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .quick-steps-header {
    font-size: 30px !important;
    padding: 0% 5% !important;
  }
}
@media (min-width: 576px) and (max-width: 768px) {
  .tutorial-card-container {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .quick-steps-header {
    font-size: 40px !important;
    padding: 0% 10% !important;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .tutorial-card-container {
    padding-left: 45px !important;
    padding-right: 45px !important;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .tutorial-card-container {
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/sell-with-pamo/component/pamo-quick-step/pamo-quick-step.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,aAAA;EACA,eAAA;EACA,4BAAA;AAAJ;;AAME;EACE,aAAA;EACA,iBAAA,EAAA,mEAAA;AAHJ;;AAME;EACE,aAAA;EACA,iBAAA,EAAA,mEAAA;AAHJ;;AAME;EACE,aAAA;EACA,iBAAA;AAHJ;;AAOE;EACE;IACE,6BAAA;IACA,8BAAA;EAJJ;EAME;IACE,0BAAA;IACA,yBAAA;EAJJ;AACF;AAOE;EACE;IACE,6BAAA;IACA,8BAAA;EALJ;EAOE;IACE,0BAAA;IACA,0BAAA;EALJ;AACF;AAQE;EACE;IACE,6BAAA;IACA,8BAAA;EANJ;AACF;AASE;EACE;IACE,6BAAA;IACA,8BAAA;EAPJ;AACF","sourcesContent":[".steps-header-text{\n    font-size:45px;\n}\n\n\n.steps-parent-header{\n    margin-top:10%;\n}\n\n.steps-card-container{\n    margin-bottom:10%;\n}\n\n.quick-steps-header{\n    font-size:55px;\n}\n\n.tutorial-card-container {\n    display: flex;\n    flex-wrap: wrap;\n    padding-left:18% !important;\n\n  }\n  \n\n\n  .tut-card-container {\n    display: flex;\n    flex-wrap: nowrap; /* Adjust this value as needed to set the spacing between columns */\n  }\n\n  .equal-height-card-wrapper {\n    display: flex;\n    flex-wrap: nowrap; /* Adjust this value as needed to set the spacing between columns */\n  }\n\n  .tutorial-card-col{\n    display: flex;\n    flex-wrap: nowrap;\n  }\n\n\n  @media (max-width: 576px) {\n    .tutorial-card-container {\n      padding-left: 15px !important;\n      padding-right: 15px !important;\n    }\n    .quick-steps-header{\n      font-size:30px !important;\n      padding:0% 5% !important;\n    }\n  }\n  \n  @media (min-width: 576px) and (max-width: 768px) {\n    .tutorial-card-container {\n      padding-left: 30px !important;\n      padding-right: 30px !important;\n    }\n    .quick-steps-header{\n      font-size:40px !important;\n      padding:0% 10% !important;\n    }\n  }\n  \n  @media (min-width: 768px) and (max-width: 992px) {\n    .tutorial-card-container {\n      padding-left: 45px !important;\n      padding-right: 45px !important;\n    }\n  }\n  \n  @media (min-width: 992px) and (max-width: 1200px) {\n    .tutorial-card-container {\n      padding-left: 60px !important;\n      padding-right: 60px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
